import styled, { css } from "styled-components";
import PropTypes from "prop-types";

import Ellipsis from "../icons/Ellipsis";

import { easingSeconds } from "../shared";
import { colors } from "../shared/colors";

const darkModeHover = `border-color: ${colors.veryLightPinkTwo};`;

const defaultFillColors = css`
    border: 1px solid transparent;
    border-radius: 50%;
    padding: 0.1875rem; /* 3px */
    width: 1.625rem; /* 26px - design says 24px but we add 2 for the border */
    height: 1.625rem; /* 26px - design says 24px but we add 2 for the border */
    transition: all ${easingSeconds};

    & path,
    & use,
    & g {
        transition: all ${easingSeconds};
        fill: ${({ transparent, active, isHeroSearchV2 }) => {
            if (active && transparent) return colors.brownGrey;
            if (active && isHeroSearchV2) return colors.veryLightPinkTwo;
            if (isHeroSearchV2) return colors.emptySearchBG;
            if (active) return colors.black;
            if (transparent) return colors.whiteDuplicate;
        }} !important;
    }

    ${({ active }) => active && darkModeHover}
`;

defaultFillColors.propTypes = {
    transparent: PropTypes.bool,
    active: PropTypes.bool,
    isHeroSearchV2: PropTypes.bool
};

const hoverFillColors = css`
    &:hover {
        ${darkModeHover}

        & path,
        & use,
        & g {
            fill: ${({ transparent, isHeroSearchV2 }) =>
                transparent
                    ? colors.brownGrey
                    : isHeroSearchV2
                    ? colors.veryLightPinkTwo
                    : colors.black};
        }
    }
`;

hoverFillColors.propTypes = {
    transparent: PropTypes.bool,
    isHeroSearchV2: PropTypes.bool
};

export const TriggerButton = styled(Ellipsis)`
    width: 1.5rem;
    cursor: pointer;
    vertical-align: middle;

    ${defaultFillColors};
    ${hoverFillColors};
`;
